import { CustomModalProps } from '../interface/interface';
import { useEffect, useRef } from 'react';
import { CloseIcon } from '../assets/svgImages';

const CustomModal = ({
  isOpen,
  onClose,
  header,
  footer,
  children,
  modalBodyClass,
  modalSize,
  disableBackdropClose = false,
}: CustomModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const autocompleteEl = document.querySelector('.pac-container');
  const ToastifyEl = document.querySelector('.Toastify');
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        isOpen &&
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        !disableBackdropClose &&
        (!ToastifyEl || !ToastifyEl.contains(event.target as Node)) &&
        (!autocompleteEl || !autocompleteEl.contains(event.target as Node))
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    if (isOpen) {
      const originalOverflow = document.body.style.overflow;
      const originalPosition = document.body.style.position;
      const originalWidth = document.body.style.width;

      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';

      return () => {
        document.body.style.overflow = originalOverflow;
        document.body.style.position = originalPosition;
        document.body.style.width = originalWidth;
        document.removeEventListener('mousedown', handleOutsideClick);
      };
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className={`overflow-y-hidden overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center md:inset-0 h-[calc(100%-1rem)] max-h-full w-full`}
    >
      <div className={`relative p-4 max-h-full ${modalSize}`}>
        <div className="relative rounded-lg shadow-sm">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t border-gray-200">
            <div className="fixed inset-0 bg-gray-800 opacity-75"></div>
            <div
              className={`relative bg-grey-50 rounded-lg shadow-lg px-3.5 lg:px-7 py-2.5 lg:py-5 w-full`}
              ref={modalRef}
            >
              <div className="flex justify-between items-center">
                <h3 className="md:text-2xl text-xl font-semibold text-primary-blue-500 w-fit">
                  {header}
                </h3>
                <CloseIcon
                  onClick={onClose}
                  className="cursor-pointer fill-primary-blue-500 sm:w-4 sm:h-4"
                />
              </div>
              <div
                className={`py-3.5 px-3 lg:py-7 ${modalBodyClass} max-h-[75vh] overflow-y-auto overscroll-contain`}
              >
                {children}
              </div>
              <div className="flex justify-center">{footer}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomModal;
